import {orderBy} from 'external/lodash'
import {
   clsx
  ,styled
  ,Fade
  ,Box 
  ,Badge
  ,Accordion 
  ,AccordionDetails 
  ,AccordionSummary 
  ,ExpandMoreIcon 
} from 'external/material'
import LinkBehavior from 'components/LinkBehavior'
import useSession from 'hooks/session'
import useStudentContext from 'hooks/student'
import useTranslations from 'hooks/translations'
import GradebookDetails from './GradebookDetails'
import { centerVertically } from 'utils/style'

import Teacher from 'components/Teacher'
import SubjectChip from 'components/SubjectChip'
import Group from 'components/Group'

const StyledGradebook = styled(Box)(gradebookStyles)

function GradeCountBadge({count}) {
  return <Badge count={count} color="primary">{children}</Badge>
}

export default function Gradebook() {
  const {navigation, groupId} = useSession()
  const {teachers, courses, assignments} = useStudentContext()
  const {translate} = useTranslations()
  
  const groups = orderBy(Object.values(courses).map(course => {
    return {...course , gradeCount: assignments && assignments[course.id] && assignments[course.id]['grade']}
  }), ['course', 'name'])


  return (
    <StyledGradebook className="container">
        <Fade in={groups.length > 0}>
          <Box className="gradebookWrapper">
            <Box className="gradebook">
              {groups.map(group => {
                const hasGrades = group.gradeCount > 0
                const expanded = navigation.gradebook.active && groupId == group.id
                const [teacherId] = group.teachers
                const teacher = teachers[teacherId] 
                return (
                  <Accordion disableGutters={true} className={clsx('gradebook',{expanded})} key={group.id} expanded={expanded} TransitionProps={{unmountOnExit: true}}>
                    <AccordionSummary
                      component={LinkBehavior}
                      to={!hasGrades || expanded ? './' : `./${group.id}`} 
                      className={clsx('gradebookSummary', {expanded})}
                      expandIcon={<ExpandMoreIcon sx={{visibility: hasGrades ? 'visible' : 'hidden'}} />}
                    >

                      <div className="gradebookSummaryContainer">
                        <Teacher course={group.course} teachers={[teacher]} />
                        <Group name={group.name} fill="#2c75bd" Badge={({children}) => <Badge sx={{paddingTop: "4px", paddingRight: "8px"}} color="primary" badgeContent={group.gradeCount}>{children}</Badge>}/>
                        <div className="subject">
                          <SubjectChip course={group.course}/>
                        </div>
                      </div>

                    </AccordionSummary>
                    <AccordionDetails className="gradebookDetails">
                      <GradebookDetails group={group}/>
                    </AccordionDetails>
                  </Accordion>
                )
              })}
            </Box>
          </Box>
        </Fade>
    </StyledGradebook>
  )
}

function gradebookStyles() {
  return {
    "&.container": {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    "& .gradebookWrapper": {
      flexGrow: 1,
      overflowY: 'auto',
      paddingBottom: 30,
      paddingLeft: 20,
      paddingRight: 11
    },
    "& .gradebook": {
      flexGrow: 1,
    },
    "& .gradebook": {
      "&:before":{
        height:0
      },
      marginTop: 20,
      borderRadius: 5,
      "&:first-of-type":{
        marginTop: 0
      },
      "&.expanded": {
      },
      textDecoration: 'none',
      display: 'flex',
      flexDirection: 'column'
    },
    "& .gradebookSummary": {
      display: 'flex',
      padding: '10px 20px',
      "&.expanded": {
      },
      "& .gradebookSummaryContainer": {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        color: '#565f77',
        fontSize: '13.5pt',
        flexShrink: 1,
        "& .subjectChip": {
          marginRight: 15,
          marginLeft: 30,
          padding: "5px 10px"
        },
        "& .subject": {
          ...centerVertically
        },
        "& .group": {
          display: 'flex',
          maxWidth: 200,
          flexGrow: 1
        },
        "& .groupIcon": {
          ...centerVertically
        },
        "& .groupName": {
          marginLeft: 10,
          ...centerVertically
        },
        "& .teacher": {
          display: 'flex',
          flexGrow: 1,
          '& .teacherName': {
            marginLeft: 15,
            ...centerVertically
          }
        }
      },
    },
    "& .gradebookDetails": {
      backgroundColor: '#f6fbfe',
      padding: 0,
      borderTop: 'solid 1px #c4c4c4',
      "& .MuiTableRow-head": {
        borderBottoc4c4c4m: 'solid 1px #c4c4c4'
      }
    },
  }
}